// @flow
import * as React from 'react';
import styled from 'styled-components';
import Card from 'common/components/Card';

const SCard = styled(Card)`
  padding: ${({ theme }) => theme.metrics.largeMargin}px;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.primaryText};
`;

type Props = {
  message: string;
}

function MessageCard({ message }: Props) {
  return (
    <SCard>
      <Text>{message}</Text>
    </SCard>
  );
}

export default MessageCard;



// WEBPACK FOOTER //
// ./src/statsradio/components/MessageCard.js